module.exports = __webpack_public_path__ + "static/media/banner-step-1.0cf863e6.png";